<template>
  <div>
    <div class="flask-stuff-holder comp" v-on:click="enlarged = !enlarged" :class="{flipped:flipped}">
      <div :class="{enlarged:enlarged}">
        <span class="svg"><img :src="src" alt=""></span>
      </div>
      <img :src="baseUrl + 'img/flask-empty.png'" alt="flask" class="flask-empty">
      <div class="fluid" :style="fluid"></div>
      <img :src="baseUrl + 'img/flask-out.png'" alt="flask" class="flask-out">
      <img v-if="flipped" :src="baseUrl + 'img/flask-out-flip.png'" alt="flask" class="flask-out">
      <transition name="fade"><div class="top-cover" v-show="top"></div></transition>
    </div>
    <span class="txt">Click or tap to zoom</span>
    <span class="txt">(Water molecules not shown)</span>    
  </div>
</template>

<script>
let cache = new Map();
export default {
  props: {
    src: { type: String, required: true },
    fluidStyle: { type: String },
    top: { type: Boolean },
    enlarged: { type: Boolean },
    flipped: { type: Boolean }
  },
  async mounted() {
    if (!cache.has(this.src)) {
      try {
        cache.set(this.src, fetch(this.src).then(r => r.text()));
      } catch (e) {
        cache.delete(this.src);
      }
    }
    if (cache.has(this.src)) {
      this.$el.getElementsByTagName('span')[0].innerHTML = await cache.get(this.src);
    }
  },
  async updated() {
    if (!cache.has(this.src)) {
      try {
        cache.set(this.src, fetch(this.src).then(r => r.text()));
      } catch (e) {
        cache.delete(this.src);
      }
    }
    if (cache.has(this.src)) {
      this.$el.getElementsByTagName('span')[0].innerHTML = await cache.get(this.src);
    }
  },
  data: function () {
    return {
      baseUrl: process.env.BASE_URL
    }
  },
  computed: {
    fluid() {
      return this.fluidStyle || 'height: 67.5%;background-position:50% 0%;background-size:300% auto;';
    }
  }  
};
</script>

<style lang="scss">
.flask-stuff-holder {
  position: relative;
  img { 
    width: 85%;
  }
  -webkit-touch-callout: none;
    -webkit-user-select: none;
     -khtml-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}
.svg {
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 5;
  svg { 
    width: 60%; 
    margin-top: 130%; 
  }
}
.demo .flask-stuff-holder.comp .svg svg {
  width: 55%;
  margin-top: 140%;
}
.svg .g {
  transform: translateY(-0.2rem) rotate(0.5deg);
  animation: float1 3s ease-in-out infinite;
}
.svg .g:nth-of-type(even) {
  transform: translateY(0px) rotate(0.5deg);
  animation: float2 3s ease-in-out infinite;
  transform-origin: 16rem 8rem;
}
.svg .g:nth-of-type(odd) { transform-origin: 12rem 6rem; }
.svg .g:nth-of-type(0) {
  animation-delay: 0s;
}
.svg .g:nth-of-type(1) {
  animation-delay: 0.35s;
}
.svg .g:nth-of-type(2) {
  animation-delay: 1s;
  transform-origin: 11rem 5.5rem;
}
.svg .g:nth-of-type(3) {
  animation-delay: 1.5s;
}
.svg .g:nth-of-type(4) {
  animation-delay: -0.15s;
}
.svg .g:nth-of-type(5) {
  animation-delay: -0.75s;
}
.svg .g:nth-of-type(6) {
  animation-delay: -1.35s;
}
@keyframes float1 {
  0% { transform: translateY(-0.4rem) rotate(0.5deg); }
  50% { transform: translateY(0.4rem) rotate(-0.5deg); }
  100% { transform: translateY(-0.4rem) rotate(0.5deg); }
}
@keyframes float2 {
  0% { transform: translateY(0px) rotate(0.5deg); }
  50% { transform: translateY(-0.5rem) rotate(0deg); }
  100% { transform: translateY(0px) rotate(0.5deg); }
}
.enlarged {
  overflow: hidden;
  z-index: 11;
  svg { 
    transition: none !important;
    animation: none !important;
    background : linear-gradient(0deg, rgba(126, 230, 230, 1) 3.84%, rgba(0, 194, 232, 1) 100%);
    border: solid 1px #ccc;
    border-radius: 50%;
    transform: scale(1.5) translateY(-2.5rem); 
  }
  svg > g { transform: scale(1.05); }
  span.txt { display: none; }
}
span.txt {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 0.75rem; 
  position: relative;
  z-index: 12;
}
.flipped {
  animation: flip 5s ease-in-out 2;
  overflow: hidden;
  svg { animation: flipsvg 10s ease-in-out 1; }
  .fluid { animation: flipfluid 5s ease-in-out 2; }
}

@keyframes flip {
  0% { transform: rotate(0deg); }
  40% { transform: rotate(188deg); }
  50% { transform: rotate(172deg); }
  60% { transform: rotate(184deg); }
  100% { transform: rotate(0deg); }
}
@keyframes flipsvg {
  0% { transform: translateY(0); }
  20% { transform: scale(0.9,0.9) translateY(-1.8rem); opacity: 0; }
  30% { transform: translateY(-1.8rem); }
  50% { transform: translateY(0); }
  70% { transform: translateY(-1.8rem); }
  80% { transform: scale(0.9,0.9) translateY(-1.8rem); opacity: 0; }
  100% { transform: translateY(0); }  
}
@keyframes flipfluid {
  0% { transform: translateY(0); }
  40% { transform: translateY(-4.2rem); }
  60% { transform: translateY(-4.2rem); }
  100% { transform: translateY(0); }
}

</style>